// extracted by mini-css-extract-plugin
module.exports = {"aiming-point":"AimingPoint_aiming-point__xcGOQ"};